var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorOpenSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4,.cls-5{fill:none;stroke:#455064;stroke-miterlimit:10;}.cls-1{stroke-width:2.59px;}.cls-2{stroke-width:2.76px;}.cls-3{fill:#455064;}.cls-4{stroke-width:0.86px;}.cls-5{stroke-width:0.86px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.37,12.71H75.63a4,4,0,0,1,4,4v67a4,4,0,0,1-4,4l-23.26.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.4,91l-25-2.82a4.49,4.49,0,0,1-4-4.47V17.15a5,5,0,0,1,4.41-5L49.3,9.06a2.72,2.72,0,0,1,3.07,2.7V88.29A2.67,2.67,0,0,1,49.4,91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 46.23,
    cy: 32.58,
    rx: 2.3,
    ry: 3.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 46.23,
    cy: 67.42,
    rx: 2.3,
    ry: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.76,
    y: 57.75,
    width: 16.44,
    height: 25.9,
    rx: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.89,54.09h1.33a.86.86,0,0,1,.86.86v2.79a0,0,0,0,1,0,0H61a0,0,0,0,1,0,0V55A.86.86,0,0,1,61.89,54.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.74,54.09h1.33a.86.86,0,0,1,.86.86v2.79a0,0,0,0,1,0,0H67.88a0,0,0,0,1,0,0V55A.86.86,0,0,1,68.74,54.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 52.37,
    y: 43.5,
    width: 21.83,
    height: 9.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 60.3,
    y: 63.56,
    width: 11.8,
    height: 17.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.41,
    y: 53.02,
    width: 0.22,
    height: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.41,
    y: 38.96,
    height: 4.54,
    transform: "translate(138.81 82.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 67.49,
    y: 38.84,
    height: 4.54,
    transform: "translate(134.98 82.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 65.39,
    y: 38.67,
    height: 4.54,
    transform: "translate(130.78 81.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 62.45,
    y: 52.73,
    width: 0.22,
    height: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 62.34,
    y: 40.73,
    height: 2.48,
    transform: "translate(124.68 83.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 59.67,
    y: 40.73,
    height: 2.48,
    transform: "translate(119.35 83.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.15,
    y: 40.73,
    height: 2.48,
    transform: "translate(114.3 83.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 52.37,
    y: 19.18,
    width: 10.92,
    height: 21.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 52.37,
    y: 21.26,
    width: 10.92,
    height: 13.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 63.3,
    y: 21.55,
    width: 5.37,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 68.67,
    y: 21.55,
    width: 3.1,
    height: 17.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenSymbol);
export default __webpack_public_path__ + "static/media/door-open-symbol.3f756f50ed02248dbb04263505390c5b.svg";
export { ForwardRef as ReactComponent };